<template>
  <el-footer class="footer-container">
    <div class="footer-text-box">
      <el-row class="item1">
        <el-col :sm="24" :md="12" :lg="12">
          <div class="grid-content bg-purple">{{formatCopyright($t('footer.copyright'))}}</div>
        </el-col>
        <el-col :sm="24" :md="12" :lg="12">
          <div class="grid-content bg-purple-light">
            <div v-html="$t('footer.terms1')"></div>
            <div class="only-one" v-html="$t('footer.terms2')"></div>
            <div v-html="$t('footer.terms3')"></div>
          </div>
        </el-col>
        <!-- <el-col :sm="24" :md="8" :lg="8"><div class="grid-content bg-purple">
            Follow Us | 
              <span>
                <i class="el-icon-info"></i>
                <i class="el-icon-info"></i>
                <i class="el-icon-info"></i>
                <i class="el-icon-info"></i>
                <i class="el-icon-info"></i>
              </span>
        </div></el-col>-->
      </el-row>
      <!-- <h4 align='center'>We are committed to meeting your CFD and forex trading needs</h4>
        <p align='center'>All trading involves risk, losses can exceed your deposits. <a href="#">Risk Policy</a>.</p>
        <div style="overflow:hidden;">
          <el-col :sm="24" :md="12" :lg="12">
            <el-col :sm="24" :md="12" :lg="12"><p>Getting started</p><p>Up to £100,000 virtual funds</p></el-col>
            <el-button :sm="24" :md="12" :lg="12">TRY DEMO ACCOUNT</el-button>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-col :sm="24" :md="12" :lg="12">Start live forex trading</el-col>
            <el-button type="warning" :sm="24" :md="12" :lg="12">OPEN LIVE ACCOUNT</el-button>
          </el-col>
      </div>-->
      <p class="legal" v-html="$t('footer.Legal')"></p>
      <p class="mark" v-html="$t('footer.riskWaring')"></p>
      <p class="distribution" v-html="$t('footer.otherInfo')"></p>
    </div>
  </el-footer>
</template>

<script>
export default {
  methods: {
    formatCopyright(val) {
      var myDate = new Date();
      var nowYear = myDate.getFullYear();
      return val.replace(/2020/g, nowYear);
    }
  }
};
</script>

<style lang="scss">
.mobileType {
  .footer-container .item1 {
    text-align: center;
    .el-col {
      padding-bottom: 10px;
    }
  }
}
.bg-purple-light {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.bg-purple-light div {
  text-align: center;
  padding: 0px 5px 0px 5px;
}
.footer-text-box {
  width: 70%;
  margin: 0 auto;
}
.only-one {
  border-left: 1px solid #7e7e7e;
  border-right: 1px solid #7e7e7e;
}
.pcType {
  .footer-container .item1 .el-col {
    text-align: center;
    &:first-child {
      text-align: left;
    }
    &:last-child {
      text-align: right;
    }
  }
}
.el-footer {
  padding: 30px 20px !important;
}

.ar-style .footer-container p.mark{
    border-right: 8px solid #f2672a;
    padding-left:0px;
    padding-right:10px;
    border-left:0;
  }

.footer-container {
  background: #23282c;
  color: #fff;
  height: auto !important;
  padding-bottom: 14px;
  font-size: 11px;
  font-family: 'Muli', "Helvetica Neue", Arial, sans-serif;
  & > p {
    text-align: left;
  }
  p.mark {
    background: #272d31;
    position: relative;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 16px;
    border-left: 8px solid #f2672a;
    // &::before {
    //   content: "";
    //   width: 3px;
    //   height: 100%;
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   background: #f1672a;
    // }
  }
  a {
    color: #fff;
  }
  a:hover {
    color: #f1672a;
    text-decoration: none;
  }
  @media (max-width: 1000px) {
    .bg-purple-light {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .footer-text-box {
      width: 100%;
      margin: 0 auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue